import React from 'react';

import { useLayoutContext } from '@contexts/LayoutContext';
import { useStateValue } from '@contexts/StateProvider';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ModelDetailsIndexMobile from '@components/ContactDetails/ModelDetails/ModelDetailsIndexMobile';
import NwDrawer from '@components/Gui/NwDrawer';

import ModelDrawerAccounting from './ModelDrawerAccounting';
import ModelDrawerBooking from './ModelDrawerBooking';
import ModelDrawerScouting from './ModelDrawerScouting';

const ModelDrawer = ({
    modelID,
    hideCalendar,
    showRating,
    scoutingModel,
    meetingImages,
    onClose,
    selectedTab,
    zIndex,
}) => {
    const [{ areaContext }] = useStateValue();

    const layoutContext = useLayoutContext();
    const { isMobile } = layoutContext;

    return isMobile ? (
        <NwDrawer width="90vw" onClose={onClose} whiteBg padding="0" title={getContactName(modelID)} zIndex={zIndex}>
            <ModelDetailsIndexMobile isDrawer modelID={modelID} selectedTab={selectedTab} />
        </NwDrawer>
    ) : areaContext.area === 'booking' || areaContext.area === 'art' ? (
        <ModelDrawerBooking
            modelID={modelID}
            hideCalendar={hideCalendar}
            showRating={showRating}
            scoutingModel={scoutingModel}
            meetingImages={meetingImages}
            onClose={onClose}
            zIndex={zIndex}
        />
    ) : areaContext.area === 'scouting' ? (
        <ModelDrawerScouting
            modelID={modelID}
            scoutingModel={scoutingModel}
            meetingImages={meetingImages}
            onClose={onClose}
            zIndex={zIndex}
        />
    ) : (
        <ModelDrawerAccounting modelID={modelID} onClose={onClose} zIndex={zIndex} />
    );
};

export default ModelDrawer;
